export default __webpack_public_path__ + "static/heart-blue-2d4f5b8e3eaf54ec0c64405e27c988a8.png";